@if (error) {
<section>
    <div
        class="error-box flex-row flex-{{ horizontalDirection }}-center"
        [style.margin]="margin"
        [style.width]="width"
    >
        <mat-icon class="error-icon">warning_amber</mat-icon>
        <p class="error-message">{{ error.message }}</p>
        @if (hasCloseButton === 'yes') {
        <button
            mat-icon-button
            type="button"
            class="close-button"
            (click)="clear()"
        >
            <mat-icon fontSet="material-icons-round">close</mat-icon>
        </button>
        }
    </div>
</section>
}
